import { combineReducers } from 'redux-immutable'
import clientListReducer from './client-master-list-reducer'
import clientCreateReducer from './client-master-create-reducer'
import clientGetReducer from './client-master-get-reducer'
import clientEditReducer from './client-master-edit-reducer'
import clientDeleteReducer from './client-master-delete-reducer'

export default combineReducers({
  clientList: clientListReducer,
  clientCreate: clientCreateReducer,
  clientGet: clientGetReducer,
  clientEdit: clientEditReducer,
  clientDelete: clientDeleteReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/client/index.js